module.exports = __webpack_public_path__ + "img/26.2d325fc4.png";